import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import TeamPopup from './TeamPopup';
// import { teamArea as content } from '../content/teamArea';

const scrollOptions = {
  animateIn: 'fadeInUp',
  animateOut: 'fadeInOut',
  animateOnce: true,
};

const Team = ({ column, teamStyle, content }) => {
  return (
    <div className="row">
      {content.map((data, index) => (
        <div className="col-lg-4 col-md-6 col-12" key={index}>
          <ScrollAnimation {...scrollOptions}>
            <div className="rn-team team-style-default style-two">
              <div className="inner" style={{ backgroundColor: '#fff' }}>
                <figure className="thumbnail">
                  <img src={data.card.img} alt={`${data.card.name[0].split(" ").join("_")}_image`} />
                </figure>
                <figcaption className="content">
                  <h2 className="title">
                    {data.card.name[0]} <br /> {data.card.name[1]}
                  </h2>
                  <h6 className="subtitle theme-gradient">{data.card.position}</h6>
                  <div className="bottom-section">
                    <p className="text-block-2">
                      {data.card.specialty.map((p, i) => (
                        <span key={i}>{p}<br /></span>
                      ))}
                    </p>
                    <span className="team-form">
                      <img src="/images/team/location.svg" alt='location-icon' />
                      <span className="location">{data.card.location}</span>
                    </span>
                    {/* <p className="description">{data.card.description}</p> */}
                    <TeamPopup popupContent={data.popup} />

                    {data.card.turnOnSocial ? (
                      <ul className="social-icon social-default icon-naked mt--20">
                        {data.card.socialNetwork.map((social, index) => {
                          return (
                            <li key={index}>
                              <a href="social.url">{social.icon}</a>
                            </li>
                          );
                        })}
                      </ul>
                    ) : null}
                  </div>
                </figcaption>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      ))}
    </div>
  );
};

export default Team;
